// Alias do cobrancasService para manter compatibilidade com BoletosList.jsx
import api from "./api";
const svc = {
  listar:       (p={})        => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/cobrancas/boletos?${qs}`); },
  imprimir:     id            => api("GET",`/cobrancas/boleto/${id}/imprimir`),
  registrarAPI: ids           => api("POST","/cobrancas/boletos/registrar-api",{ids}),
  cancelar:     (id,motivo)   => api("PATCH",`/cobrancas/boletos/${id}/cancelar`,{motivoCancelamento:motivo}),
  reemitir:     (id,data)     => api("POST",`/cobrancas/boletos/${id}/reemitir`,data),
  relatorio:    (p={})        => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/cobrancas/relatorio/adimplencia?${qs}`); },
  imprimirRel:  (p={})        => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/cobrancas/relatorio/imprimir?${qs}`); },
  dadosEnvio:  (id)        => api("GET",  `/boletos/${id}/dados-envio`),
  enviar:      (id,data)   => api("POST", `/boletos/${id}/enviar`, data),
  enviarLote:         (data)    => api("POST", "/boletos/enviar-lote", data),
  marcarRegistrado:   (id)      => api("PATCH",`/boletos/${id}/marcar-registrado`),
  confirmarPix:       (id,data) => api("POST", `/boletos/${id}/confirmar-pix`, data),
};
export default svc;
